/* eslint-disable react/require-default-props */

import clsx from "clsx"
import React, { forwardRef } from "react"

interface IPageGridProps {
  className?: string
  isGrid?: boolean
  id?: string
  children?: React.ReactNode
}

// Notice that we're using the `forwardRef` right here instead of React.forwardRef
const PageGrid = forwardRef<HTMLDivElement, IPageGridProps>(
  ({ children, className, isGrid = true, id }, ref) => (
    <div
      ref={ref}
      id={id}
      className={clsx(
        className,
        "xl:max-w-layout-xl lg:mx-auto lg:max-w-layout-lg",
        isGrid
          ? "grid grid-cols-2 mx-4 gap-x-4 md:grid-cols-4 md:gap-x-8 lg:gap-x-10 xl:gap-x-12 lg:grid-cols-12"
          : "flex mx-4",
      )}
    >
      {children}
    </div>
  ),
)

// Setting displayName for the component for better debugging
PageGrid.displayName = "PageGrid"

export default PageGrid
